export class CustomPart {
  constructor(part) {
    this.order = part.partOrder;
    this.uid = part.partUID;
    this.name = part.partName;
    this.type = part.partType;
    this.typeCats = part.partTypeCats;
    this.frontSrc = part.partFront;
    this.backSrc = part.partBack;
    this.frontImage = undefined;
    this.backImage = undefined;
    this.originalFrontImage = undefined;
    this.originalBackImage = undefined;
    this.loaded = false;
    this.choice_value = (part.choice_value)?part.choice_value:undefined;  
    this.customShadow = undefined;
    this.customShadowSRC = (part.customShadow)?part.customShadow:undefined;
  }
  draw(ctx, image, sx, sy, dWidth, dHeight) {
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;
    ctx.shadowBlur = dWidth * 0.01;
    ctx.shadowColor = "rgba(0,0,0,0.3)";
    ctx.globalCompositeOperation = "source-over";
    ctx.drawImage(image, sx, sy, dWidth, dHeight);
  }
  getFrontSrc() {
    return this.frontSrc;
  }
  getBackSrc() {
    return this.backSrc;
  }
  setFrontImage(image) {
    this.frontImage = image;
  }
  setBackImage(image) {
    this.backImage = image;
  }
  setOriginalFrontImage(image) {
    this.originalFrontImage = image;
  }
  setOriginalBackImage(image) {
    this.originalBackImage = image;
  }
  async load() {
    let backPromise, frontPromise, customShadowPromise;
    if (this.backSrc) {
      backPromise = new Promise((backResolve) => {
        const bImage = new Image();
        bImage.crossOrigin = 'Anonymous'
        bImage.addEventListener("load", () => {
          this.backImage = this.originalBackImage = bImage;
          backResolve(this.backImage);
        });
        bImage.src = this.backSrc;
      });
    }
    if (this.frontSrc) {
      frontPromise = new Promise((frontResolve) => {
        const fImage = new Image();
        fImage.crossOrigin = 'Anonymous'
        fImage.addEventListener("load", () => {
          this.frontImage = this.originalFrontImage = fImage;
          frontResolve(this.frontImage);
        });
        fImage.src = this.frontSrc;
      });
    }
    if (this.customShadowSRC) {
      customShadowPromise = new Promise((customShadowResolve) => {
        const shadowImage = new Image();
        shadowImage.crossOrigin = 'Anonymous'
        shadowImage.addEventListener("load", () => {
          this.customShadow = shadowImage;
          customShadowResolve(this.shadowImage);
        });
        shadowImage.src = this.customShadowSRC;
      });
    }

    await Promise.all([backPromise, frontPromise, customShadowPromise])
      .then((result) => {
        this.loaded = true;
        // console.log(result);
      })
      .catch((err) => {
        console.error(err);
      });
  }
}
